var map = {
	"./link_attacking_down_blue_0.png": "0df5",
	"./link_attacking_down_blue_1.png": "61d8",
	"./link_attacking_down_green_0.png": "67d3",
	"./link_attacking_down_green_1.png": "ab05",
	"./link_attacking_left_blue_0.png": "77ed",
	"./link_attacking_left_blue_1.png": "d689",
	"./link_attacking_left_green_0.png": "6816",
	"./link_attacking_left_green_1.png": "3e9e",
	"./link_attacking_right_blue_0.png": "9a82",
	"./link_attacking_right_blue_1.png": "7f2c",
	"./link_attacking_right_green_0.png": "0604",
	"./link_attacking_right_green_1.png": "2611",
	"./link_attacking_up_blue_0.png": "e8ed",
	"./link_attacking_up_blue_1.png": "fc57",
	"./link_attacking_up_green_0.png": "a59b",
	"./link_attacking_up_green_1.png": "0597",
	"./link_celebrating_blue_0.png": "a61d",
	"./link_celebrating_blue_1.png": "8763",
	"./link_celebrating_green_0.png": "6a52",
	"./link_celebrating_green_1.png": "ecab",
	"./link_walking_down_blue_0.png": "83ad",
	"./link_walking_down_blue_1.png": "f272",
	"./link_walking_down_green_0.png": "1fd9",
	"./link_walking_down_green_1.png": "1867",
	"./link_walking_left_blue_0.png": "2138",
	"./link_walking_left_blue_1.png": "5acb",
	"./link_walking_left_green_0.png": "6488",
	"./link_walking_left_green_1.png": "53a5",
	"./link_walking_right_blue_0.png": "9655",
	"./link_walking_right_blue_1.png": "fc88",
	"./link_walking_right_green_0.png": "cc6d",
	"./link_walking_right_green_1.png": "e62f",
	"./link_walking_up_blue_0.png": "a66c",
	"./link_walking_up_blue_1.png": "5b7b",
	"./link_walking_up_green_0.png": "d57c",
	"./link_walking_up_green_1.png": "9342"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df8b";